<template>
	<ConfirmationDialog
		className="date-change-dialog"
		:actions="actions"
	>
		<template v-slot:header>
			<div>
				{{ $t("common.DateChangeDialog_title") }}
			</div>
		</template>

		<template v-slot:description>
			<div>
				<Calendar
					v-model="dateModel"
					:inline="true"
					:showTime="true"
					hourFormat="12"
				/>
			</div>
		</template>
	</ConfirmationDialog>
</template>

<script>
import moment from "moment-timezone";

import {
	ConfirmationDialog
} from "@teaming/common-ui";

export default {
	name: "DateChangeDialog",

	components: {
		ConfirmationDialog,
	},

	emits: [ "cancel", "dateChange", ],

	data() {
		return {
			dateModel: this.date,
		};
	},

	props: {
		date: {
			type: Object,
			required: true,
		},
		subDocId: {
			type: String,
			required: true,
		},
	},

	computed: {
		actions() {
			return [
				{
					id: "save",
					type: "PRIMARY",
					label: this.$t( "common.DateChangeDialog_btnSubmit" ),
					isDestructive: false,
					onButtonPress: () => {
						const newDate = moment( this.dateModel ).startOf( "minute" ).utc().format( "YYYY-MM-DD HH:mm:ss" );
						this.$emit( "dateChange", { date: newDate, subDocId: this.subDocId, } );
					},
				},
				{
					id: "cancel",
					type: "SECONDARY",
					label: this.$t( "common.DateChangeDialog_btnCancel" ),
					isDestructive: false,
					onButtonPress: () => {
						this.$emit( "cancel" );
					},
				},
			];
		},
	},

	methods: {},
};
</script>

<style lang="scss">
.date-change-dialog {
	.confirmation-dialog__content {
		max-width: 50rem;
	}
	.p-datepicker-inline {
		box-shadow: none !important;
	}
}
</style>
